var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBalanceCardUpIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 63,
    height: 72,
    viewBox: "0 0 63 72",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1459_45605)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M46.5413 71.3027C55.2071 71.3027 63.5469 69.0317 70.8449 64.7128C72.2475 63.8813 72.6316 62.0902 71.6772 60.8012L68.3657 56.3372C67.5044 55.1765 65.8515 54.8417 64.577 55.5783C59.1471 58.7254 52.9664 60.3771 46.5413 60.3771C40.1163 60.3771 33.9356 58.7254 28.5115 55.5783C27.237 54.8417 25.5841 55.171 24.7228 56.3372L21.4113 60.8012C20.4569 62.0902 20.8352 63.8813 22.2436 64.7128C29.5416 69.0317 37.8814 71.3027 46.5472 71.3027H46.5413Z",
    fill: "#131A2D",
    fillOpacity: 0.1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.5765 52.7766L17.0403 49.3672C18.1984 48.48 18.4661 46.8841 17.6339 45.7123C13.6706 40.1546 11.5871 33.6874 11.5871 26.8631C11.5871 20.7083 13.3098 14.7768 16.5922 9.57066C17.3604 8.34864 17.017 6.76392 15.8007 5.93808L11.1448 2.76306C9.80041 1.84794 7.93225 2.21622 7.0651 3.561C2.56055 10.5583 0.191881 18.5545 0.191881 26.8631C0.191881 35.9027 3.10179 44.786 8.44439 52.1795C9.38721 53.4852 11.2787 53.7698 12.5765 52.7766Z",
    fill: "#131A2D",
    fillOpacity: 0.1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M46.5407 49.1376C33.7096 49.1376 23.3079 39.1646 23.3079 26.8623C23.3079 14.5599 33.7096 4.58691 46.5407 4.58691C59.3718 4.58691 69.7734 14.5599 69.7734 26.8623C69.7734 39.1646 59.3718 49.1376 46.5407 49.1376Z",
    fill: "#131A2D",
    fillOpacity: 0.1
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1459_45605"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M62.9854 0H0.0841904V71.3023H62.9854V0Z",
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBalanceCardUpIcon);
export default __webpack_public_path__ + "static/media/balance-card-up-icon.fcab0be444faac2f5ec3bffcb3abf420.svg";
export { ForwardRef as ReactComponent };